import DialogActions from '@mui/material/DialogActions';
import { Button, useTranslate } from 'react-admin';
import { useMultiSelectionContext } from 'utils/providers/MultiSelectionProvider';
import { FileManagerModalInputDialog } from './FileManagerModalInputDialog';
import { FileManagerModalInputDialogContentProvider } from './FileManagerModalInputDialogContentProvider';
import { FileManagerModalInputDialogContentSelected } from './FileManagerModalInputDialogContentSelected';

interface FileManagerModalInputDialogContentProps {
  source?: string,
  handleSelectClick: (selection: Array<any>) => void,
  handleCloseClick: () => void,
}
export const FileManagerModalInputDialogContent = ({ source, handleSelectClick, handleCloseClick }: FileManagerModalInputDialogContentProps) => {
  const translate = useTranslate();
  const { selection, clearSelection } = useMultiSelectionContext();
  const onSelectClick = () => {
    handleSelectClick(selection);
  }
  const handleClearClick = () => { clearSelection(); }

  console.log('FileManagerModalInputDialogContent');
  return (
    <FileManagerModalInputDialogContentProvider>
      <FileManagerModalInputDialog source={source} />
      <DialogActions>
        <FileManagerModalInputDialogContentSelected source={source} />
        <Button onClick={onSelectClick} label={translate("ra.action.confirm")} disabled={0 === selection.length} />
        <Button onClick={handleClearClick} label={translate("ra.action.clear_input_value")} disabled={0 === selection.length} />
        <Button onClick={handleCloseClick} label={translate("ra.action.close")} />
      </DialogActions>
    </FileManagerModalInputDialogContentProvider>
  )
}
